<template>
  <rich-button @click="commands.bullet_list" v-bind:isActive="isActive.bullet_list()" v-bind:icon="'list-ul'" />
</template>

<script>
  import BulletListButton from './BulletListButton.ts'
  export default BulletListButton
</script>
